import './index.scss';

//import * as Lightgallery from '../assets-base/assets-src/js/Spinao/Lightgallery';
//import * as OffcanvasMenu from '../assets-base/assets-src/js/Spinao/OffcanvasMenu';
//import * as StickyTopMenu from '../assets-base/assets-src/js/Spinao/StickyTopMenu';
//import '../assets-base/assets-src/js/Bootstrap/dropdown';
//import '../assets-base/assets-src/js/Bootstrap/collapse';
//import '../assets-base/assets-src/js/Bootstrap/alert';
//import '../assets-base/assets-src/js/Bootstrap/button';
//import '../assets-base/assets-src/js/Bootstrap/carousel';
//import '../assets-base/assets-src/js/Bootstrap/collapse';
//import '../assets-base/assets-src/js/Bootstrap/modal';
//import '../assets-base/assets-src/js/Bootstrap/offcanvas';
//import '../assets-base/assets-src/js/Bootstrap/popover';
//import '../assets-base/assets-src/js/Bootstrap/scrollspy';
//import '../assets-base/assets-src/js/Bootstrap/tab';
//import '../assets-base/assets-src/js/Bootstrap/toast';
//import '../assets-base/assets-src/js/Bootstrap/tooltip';
import * as UnifyHeight from '../assets-base/assets-src/js/Spinao/UnifyHeight';
//import * as GoogleMaps from '../assets-base/assets-src/js/Spinao/GoogleMaps';
//import * as NetteAjaxForm from '../assets-base/assets-src/js/Spinao/NetteAjaxForm';

//import '../assets-base/assets-src/js/Spinao/Masonry';
//import '../assets-base/assets-src/js/Spinao/GoogleReCaptcha';
//import "../assets-base/assets-src/js/Spinao/CookieConsent";



document.addEventListener("DOMContentLoaded", function() {
   /* Lightgallery.applyTo('[data-lightgallery="area"]', {
        selector:'[data-lightgallery="image"]',
        fullScreen:false,
        zoom:false,
        hash:false,
        pager:false
    });

    OffcanvasMenu.initialize();
    //StickyTopMenu.initialize();

    NetteAjaxForm.initialize('[data-ajax="form"]');*/

    //GoogleMaps.initialize();


    UnifyHeight.applyDataAttribute();
});
